// Display text for an earned badge: "<emoji> <translated label>".
// New backends send { emoji, label }; old ones only { name: "<emoji> <Label>" }.
const LEADING_EMOJI = /^[^\p{L}\p{N}]+/u;

export function badgeDisplayName(badge, t = (s) => s) {
  if (!badge) return "";
  if (badge.label) {
    return badge.emoji ? `${badge.emoji} ${t(badge.label)}` : t(badge.label);
  }
  const name = String(badge.name || "");
  const emoji = (name.match(LEADING_EMOJI) || [""])[0].trim();
  const rest = name.replace(LEADING_EMOJI, "").trim();
  if (!rest) return name;
  return emoji ? `${emoji} ${t(rest)}` : t(rest);
}
